import { render, staticRenderFns } from "./Rollups.vue?vue&type=template&id=45136f12&"
import script from "./Rollups.vue?vue&type=script&lang=ts&"
export * from "./Rollups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports